/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */
import { HttpClient } from './httpClient'
import { formatHTS } from '../util'
import { deletePgaFormData } from './deleteFormData';
import { showToast } from "../util/showToast";
export const getHTSData = (code,mycountry,epochs) => {
  const data = {
    eventMessage: {
      country: mycountry,
       htsCode: formatHTS(code),
       eta: epochs
    },
    eventType: 'GET_HTS_TREE',
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}

export const getHSDtlList_old = htsArray => {
  const data = {
    eventMessage: {
      hsList: htsArray.map(hts => ({
        country: 'US',
        hsVersion: '2019Rev2.0',
        hsCodeRoot: hts
      })),
      country: 'US',
      hsVersion: '2019Rev2.0'
    },
    eventType: 'GET_HS_DTL_LIST_HS',
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}

export const deleteUnusedPGAS = (pgasFlagsToShowOnUi, pgasFlagsToDelete,  merchandiseId, shipmentId, lineItemIndex, invoiceItemIndex,
  updateMerchLineItemPgaObject,updateMerchLineItemFeild, doittwice) => {


  let deletionResponse = deletePgaFormData(pgasFlagsToDelete, merchandiseId, shipmentId)
  
  // console.log('currentFormsSelected: ', currentFormsSelected);
  console.log('selectedFormTypesxx: ', pgasFlagsToShowOnUi);
  updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, "selectedFormTypes", pgasFlagsToShowOnUi.map(a=>a.pgaType))
  updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, "pgaFlagInfos", pgasFlagsToShowOnUi)
  return deletionResponse;
  
}

export const getHSDtlList = (itDate, allEntryData, hts,countryOfOrigin) => {
  if(typeof allEntryData == 'number'){
    showToast("Invalid entrytype info! Report this as a bug immediately!");

  }
  let entryDateOrReleaseDate =  allEntryData?.releaseDate?.epochs || 0;
  if(entryDateOrReleaseDate < 1000){
    entryDateOrReleaseDate = itDate || 0;
  }
  if(entryDateOrReleaseDate < 1000){
    entryDateOrReleaseDate = allEntryData?.entryDate?.epochs || 0;
  }
  if(entryDateOrReleaseDate < 1000){
    entryDateOrReleaseDate = 0;
  }
  if(!entryDateOrReleaseDate){
    showToast("IT Date, Release Date and Entry Date are missing!");
  }

  
  let cacheName = `GLOBAL_CURRENTDETAILSCACHE_${Math.floor(Date.now()/ (1000 *60 *60 * 3))}_${countryOfOrigin}_${entryDateOrReleaseDate}_${hts}`;
  if(window[cacheName])return window[cacheName]


  const data = {
    "eventMessage": {
        "country": "US",
        "htsCode": hts,
        "eta": entryDateOrReleaseDate,
    },
    "eventType": "GET_HTS_METADATA",
    "eventTime": Date.now()
  }
  if(countryOfOrigin){
    data.eventMessage.countryOfOrigin = countryOfOrigin;
  }
  
  let responseForDetail = HttpClient.custom({
    data
  })
  window[cacheName] = responseForDetail;
  return responseForDetail;
}
export const getPGATemplate = (formType) => {
  const data = {
    "eventMessage": {
        formType
    },
    "eventType": "GET_PGA_TEMPLATE",
    "eventTime": Date.now()
  }


  return HttpClient.custom({
    data
  })
}



/*
export const getHSDtl = hts => {
  const data = {
    eventMessage: {
      hsCodeRoot: hts,
      country: 'US',
      hsVersion: '2019Rev2.0'
    },
    eventType: 'GET_HS_DTL_HS',
    eventTime: Date.now()
  }
  console.log('GET_HS_DTL_HS', data)
  return HttpClient.custom({
    data
  })
}
*/

export const getHSTotalDCT = (hsList, entryTime, calMode, totHMF, totMPF, totDuty, totTax, totalUserFees) => {
  let data = {
    eventMessage: {
      country: 'US',
      hsVersion: '2019Rev2.0',
      calMode,
      entryTime: entryTime ? entryTime.toString() : Date.now().toString()
    },
    eventType: 'GET_HS_TOTAL_DCT_HS',
    eventTime: Date.now()
  }
  if (!hsList) {
    data.eventMessage.totHMF = totHMF
    data.eventMessage.totMPF = totMPF
    data.eventMessage.totDuty = totDuty
    data.eventMessage.totTax = totTax
    data.eventMessage.totUserFee = totalUserFees
  } else {
    data.eventMessage.hsList = hsList
  }
  return HttpClient.custom({
    data
  })
}

export const gethsDataDtlListBody = (params) => {
  let {
    uiValue,
    htsCode,
    tradeAgreement,
    modeOfTransport,
    enteredValue,
    entryType,
    portEntry,
    portOfUnlading,
    countryOfOrigin,
    itemId,
    // OverWrite Fields
    hmfVal,
    mpfVal,
    duty,
    dutyRate
  } = params
  if (tradeAgreement === 'NONE') {
    tradeAgreement = null
  }
  let result = {
    country: 'US',
    hsCodeRoot: htsCode,
    hsVersion: '2019Rev2.0',
    hsTrade: tradeAgreement,
    countryOrigin: countryOfOrigin,
    modeTransport: modeOfTransport,
    value: enteredValue,
    entryType,
    portEntry,
    portUnLading: portOfUnlading,
    uiValue,
    itemId
  }
  if (uiValue === 'Y') {
    return Object.assign(result, { dutyRate, hmfVal, mpfVal, duty })
  } else {
    return result
  }
}